import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import { config } from "@unlikelyai-magic/shared/config";
import { AuthState } from "../../authSlice";

export const baseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) =>
  fetchBaseQuery({
    baseUrl: config.DISCLOSURE_SERVICE_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const { auth } = getState() as { auth: AuthState };
      if (auth.accessToken)
        headers.set("Authorization", `Bearer ${auth.accessToken}`);
    },
  })(args, api, extraOptions);
